import cookie from 'react-cookies';
import useTrans from "@hooks/translation";
import {isEmpty} from '@helpers/helpers';
import {inArray, is_array} from "@helpers/arrays";
import {shortMoneyNumber} from "@helpers/numbers";
import {getPropertyDetails} from "@models/property";
import {getVillaTypes, getUrlDealTypes, getUrlTypes} from "@models/property";
import {str_replace} from "@helpers/helpers";
import {getAvatar, getRealtorProfileUrl} from "@models/user";
import {getAgencyProfileUrl, getLogo} from "@models/agency";
import {getCity} from "@models/district";
import {pluckKeyToArray} from "@hooks/selection.options";
import {getDefaultPrices} from "../../../hooks/prices";
import {getDefaultInfrastructureArea} from "../../../hooks/infrastructure_area";
import {investmentCities} from "../invest/helpers";
import {array_unique} from "../../../helpers/arrays";
import {getAparatVideoPath} from "../../../../models/property";

export const handleTypeTitle = (deal_type, type, villa_type) => {
    return useTrans('deal_type.' + deal_type) + ' ' + useTrans('type.' + type) + (!isEmpty(villa_type) ? (' ' + getVillaTypes(villa_type)) : '');
};

export const handleTitle = (property, showCityName = false, selectedCityId = null, selectedDistrictId = null, streetShow = false, districtShow = true) => {
    let {infrastructure_area, land_area, district_name, street, type} = property;
    let city_name = '';
    let districtName = district_name;
    let streetName = street;
    let selectedCity = null;

    if (!isEmpty(selectedDistrictId) && is_array(selectedDistrictId) && selectedDistrictId.length === 1) {
        const district = selectedDistrictId[0];

        const holyShrineDistrictId = 2759;
        if ((property.district_id !== district.value) && (district.type === 'district') && district.value !== holyShrineDistrictId) {
            districtName = 'محدوده ' + district.label;
        }
    }

    if (!isEmpty(selectedCityId)) {
        selectedCity = getCity(selectedCityId);
    }

    if (!districtShow && !isEmpty(street)) {
        districtName = '';

        let propertyStreet = str_replace('/', '.', street);
        propertyStreet = str_replace('-', '.', propertyStreet);
        propertyStreet = str_replace('٫', '.', propertyStreet);

        const dirtyStreet = ['اوایل', 'اواسط', 'ابتدا', 'انتها', 'حاشیه'];

        if (Number(propertyStreet)) {
            streetName = district_name + ' ' + street
        } else if (propertyStreet && inArray(propertyStreet.trim(), dirtyStreet)) {
            streetName = street + ' ' + district_name;
        }
    }

    if (showCityName || (!isEmpty(selectedCity) && selectedCity.id !== property.city_id && selectedCity.type !== 'city')) {
        city_name = property.city_name;
    }

    let area = '';
    if (!isEmpty(land_area) && inArray(type, ['house', 'land', 'villa', 'garden', 'old_house'])) {
        area = land_area;
    } else if (!isEmpty(infrastructure_area)) {
        area = infrastructure_area;
    }

    let result = '';

    if (!isEmpty(area)) {
        result += area + ' متر';
    }

    if (!isEmpty(city_name)) {
        result += '، ' + city_name;
    }

    if (!isEmpty(districtName)) {
        result += '، ' + districtName;
    }

    if (!isEmpty(streetName) && (isEmpty(selectedCityId) || selectedCityId === property.city_id || streetShow)) {
        result += '، ' + streetName;
    }

    return result;
};

function getPricingKeysByDealType($dealType, $type) {
    const lists = {
        'sale': ['exchange', 'price', 'price_per_meter', 'price_validated', 'loan', 'installment'],
        'rent': ['mortgage', 'rent', 'exchangeable'],
        'mortgage': ['mortgage', 'exchangeable'],
        'pre_sale': ['exchange', 'price', 'price_per_meter', 'price_validated', 'loan', 'installment'],
        'exchange': ['exchange', 'price', 'price_per_meter', 'price_validated', 'loan', 'installment'],
        'participation': ['price', 'price_per_meter', 'price_validated'],
    };

    let keys = lists[$dealType];

    if ($dealType === 'sale' && $type === 'villa') {

    }

    return keys;
}

export function handlePropertyPrice(property, isPropertyList = false, northCitiesIds = []) {
    const {deal_type} = property;

    if (inArray(deal_type, ['sale', 'exchange', 'pre_sale', 'participation'])) {
        let price = shortMoneyNumber(property.price, '٫');
        let label = '';
        let extraLabel = '';
        let hasPrepayment = false;

        if (!isEmpty(property.prepayment) && property.prepayment > 0 && (isEmpty(property.price) || property.hide_price)) {
            price = shortMoneyNumber(property.prepayment, '٫');
            label = 'پیش‌پرداخت';
            hasPrepayment = true;

        } else if (!isEmpty(property.prepayment) && property.prepayment > 0 && property.type === 'villa') {
            const prepayment = shortMoneyNumber(property.prepayment, '٫');
            extraLabel = 'پیش‌پرداخت ' + prepayment.num + ' ' + prepayment.unit;
            hasPrepayment = true;

        } else if (!isEmpty(property.price_per_meter) && (!property.negotiable || !isPropertyList) && property.price_per_meter > 0) {
            //if (!inArray(property.city_id, northCitiesIds)) {
            if (property.type !== 'villa') {
                let price_per_meter = shortMoneyNumber(property.price_per_meter, '٫', true);
                extraLabel = 'متری ' + price_per_meter.num + ' ' + price_per_meter.unit;
            }
        }

        if (deal_type === 'pre_sale') {

        }

        let result = [
            {price: price, label: label, extraLabel: extraLabel}
        ];

        if (!isEmpty(property.loan) && property.loan > 0) {
            const loanPrice = shortMoneyNumber(property.loan, '٫');
            loanPrice.unit += ' وام';
            let loanLabel = '';

            if (isPropertyList) {
                result[0].extraLabel = ''; // empty if extraLabel has price_per_meter value

                result.push({price: '', label: '', extraLabel: loanPrice.num + ' ' + loanPrice.unit});

            } else if (!isPropertyList || !hasPrepayment) { // add loan labels
                if (!isEmpty(property.installment) && property.installment > 0) {
                    const installment = shortMoneyNumber(property.installment, '٫');
                    loanLabel = 'هر قسط ' + installment.num + ' ' + installment.unit
                }

                result.push({price: loanPrice, label: '', extraLabel: loanLabel});
            }
        }

        return result;

    } else if (deal_type === 'rent') {
        const mortgage = shortMoneyNumber(property.mortgage, '٫');
        const rent = shortMoneyNumber(property.rent, '٫');

        return [
            {price: mortgage, label: 'رهن'},
            {price: rent, label: 'اجاره'}
        ];
    } else if (deal_type === 'mortgage') {
        const mortgage = shortMoneyNumber(property.mortgage, '٫');

        return [
            {price: mortgage, label: 'رهن کامل'}
        ];
    } else {
        return [];
    }
}

export function handlePropertyFeatures(property, max = 5) {
    const features = [...getPropertyDetails(property, max)];

    if (typeof features === "object" && features.length) {
        return features.map((item, key) =>
            <span key={key} className="details-segment">
                {item[1]}
            </span>
        )
    }
}


export function getPropertyUrl(property, isBadeSaba = false) {
    const {city_name, deal_type, type, district_name, slug, land_area, infrastructure_area} = property;

    const $dealType = getUrlDealTypes(deal_type);
    const $type = getUrlTypes(type);

    let $mainArea = '';
    if (!isEmpty(land_area) && inArray(type, ['house', 'land', 'villa', 'garden', 'old_house'])) {
        $mainArea = land_area;
    } else if (!isEmpty(infrastructure_area)) {
        $mainArea = infrastructure_area;
    }

    let url = '/املاک-' + str_replace(' ', '-', city_name) + '/' + $dealType + '-' + $type + '/' + str_replace(' ', '-', district_name) + '/p-' + slug + '-' + $mainArea + '-متری';

    let media_count = 0;
    if (!isEmpty(property.media)) {
        media_count = (property.media.length > 5) ? 5 : property.media.length;
    }

    return url + '?media=' + media_count + (isBadeSaba ? '&badesaba=true' : '');
}

export function getContactItems(property, isBadeSaba = false) {
    const {contact_info, archived, request_contact} = property;
    const showRequestForm = (request_contact || isBadeSaba);

    let avatarPath = getAvatar('');
    let profileUrl = null;
    let avatarType = 'user';
    let realtorName = (!isEmpty(contact_info) && !isEmpty(contact_info.name)) ? contact_info.name : 'بدون نام';
    let agencyName = (!isEmpty(contact_info) && !isEmpty(contact_info.agency_name)) ? contact_info.agency_name : 'مالک این ملک';

    if (!isEmpty(contact_info) && !showRequestForm) {

        if (!isEmpty(property.agency_id) && !isEmpty(contact_info.agency_id) && property.agency_id === contact_info.agency_id) {
            realtorName = '';
            avatarPath = getLogo('');
            avatarType = 'agency';

            if (!archived) {
                profileUrl = getAgencyProfileUrl(contact_info);
                if (!isEmpty(contact_info.avatar)) {
                    avatarPath = getLogo(contact_info.agency_id);
                }
            }
        } else if (!isEmpty(contact_info.realtor_id) && !archived) {
            profileUrl = getRealtorProfileUrl(contact_info);
            realtorName = contact_info.realtor_name;

            if (!isEmpty(contact_info.avatar)) {
                avatarPath = getAvatar(contact_info.realtor_id);
            }
        } else if (!isEmpty(contact_info.id) && !isEmpty(contact_info.avatar) && !archived) {
            avatarPath = getAvatar(contact_info.id);
        }
    }

    return {
        avatarPath: avatarPath,
        profileUrl: profileUrl,
        avatarType: avatarType,
        realtorName: realtorName,
        agencyName: agencyName,
    }
}

export function checkUserModality({city_id, district_id, deal_type}, allowRent = false) {
    let type = '';
    let show_invest = false;
    let city_name = '';
    let cityId = city_id;

    let districtIds = [];
    if (!isEmpty(district_id) && is_array(district_id)) {
        districtIds = pluckKeyToArray(district_id, 'value');
    }

    if (isEmpty(deal_type) || allowRent || (!allowRent && deal_type !== 'rent' && deal_type !== 'mortgage')) {

        for (let city of investmentCities) {
            if (Number(city_id) === Number(city.id)) {
                type = city.en_name;
                show_invest = true;
                city_name = city.fa_name;
            }
        }

        /*if (city_id === 262 || (!isEmpty(district_id) && (inArray(199, districtIds) || district_id === 199))) {
            //  262: Golbahar Id
            type = 'golbahar';
            show_invest = true;
            city_name = 'گلبهار';
            cityId = 262;
        } else {
            for (let city of investmentCities) {
                if (Number(city_id) === Number(city.id)) {
                    type = city.en_name;
                    show_invest = true;
                    city_name = city.fa_name;
                }
            }
        }*/
    }


    return {
        type: '',
        city_id: cityId,
        city_name: city_name,
        show_invest: show_invest,
        show_invest_modal: false,
    }
}

function checkCityRobotNoIndex(city_id) {
    const cities = [
        // 3504, // محمدشهر
        // 6377, // زیباکنار
        // 3406, // دماوند
        // 8142, // بومهن
        // 3722, // فرزادشهر
        // 1067, // چناران
        // 1614, // رودسر
        // 1362, // قائم شهر
        // 1716, // گلمکان
        // 1071, // خشکبیجار
        // 3429, // کلارآباد
        // 960, // اهواز
        // 1184, // صفادشت
        // 1323, // بندرگز
        // 10759, // ورامین
        // 18962, // سمنان
        // 7964, // مينودشت
        // 1327, // علی آباد کتول
        // 15419, // صباشهر
        // 44451, // آستانه اشرفیه
        // 22201, // توتكابن
    ];

    return inArray(city_id, cities);
}

export const handlePageRobots = async (params, searchWidgetUrl = null, isBadeSaba = false) => {
    let robots = 'index, follow, all';

    const city_id = !isEmpty(params['city_id']) ? params['city_id'] : 259;
    const pricesArray = getDefaultPrices();
    const infrastructureAreaArray = getDefaultInfrastructureArea();

    if (
        !isEmpty(city_id) && Number(city_id) === 259
        && (
            (!isEmpty(params['min_price']) || !isEmpty(params['max_price']))
            || (!isEmpty(params['min_infrastructure_area']) || !isEmpty(params['max_infrastructure_area']))
        )
    ) {
        if ((!isEmpty(params['min_price']) && !inArray(params['min_price'], pricesArray)) || (!isEmpty(params['max_price']) && !inArray(params['max_price'], pricesArray))) {
            robots = 'NOODP, nofollow, noindex';
        }

        if ((!isEmpty(params['min_infrastructure_area']) && !inArray(params['min_infrastructure_area'], infrastructureAreaArray)) || (!isEmpty(params['max_infrastructure_area']) && !inArray(params['max_infrastructure_area'], infrastructureAreaArray))) {
            robots = 'NOODP, nofollow, noindex';
        }
    }

    if (checkCityRobotNoIndex(city_id)) {
        robots = 'NOODP, nofollow, noindex';
    }

    if (isBadeSaba) {
        robots = 'NOODP, nofollow, noindex';
    }

    return robots;
};

export function checkPropertyIsAssignedAndOwner(property) {
    let assigned = false;

    if (is_array(property.stage) && inArray('assigned', property.stage)) {
        assigned = true
    } else if (!is_array(property.stage) && property.stage === 'assigned') {
        assigned = true
    }

    let result = false;
    if (!property.archived && assigned && property.registered_by !== 'realtor') {
        result = true;
    }

    return result;
}

export function getPropertyVideoPath(property) {
    let path = null;

    if (property && property.media && property.media.length) {
        for (let item of property.media) {
            if (item.type === 'video') {
                path = getAparatVideoPath(item.code)
            }
        }
    }

    return path;
}

export function checkGridView(city_id) {
    const cities = [3614];
    return true; // (inArray(Number(city_id), cities));

    /*let propertiesView = cookie.load('properties_view');

    if (!isEmpty(req)) {
        propertiesView = req.cookies.properties_view;
    }

    // save A/B testing
    if (grid && isEmpty(propertiesView)) {
        const propertiesViewTypes = ['list', 'grid'];
        const random = Math.floor(Math.random() * propertiesViewTypes.length);
        propertiesView = propertiesViewTypes[random];

        if (!isEmpty(res)) {
            res.cookie('properties_view', propertiesView, {maxAge: 2592000000, httpOnly: false, secure: false, path: '/'}); // 30 day
        } else if (process.browser) {
            saveCookie('properties_view', propertiesView)
        }
    }

    if (full) {
        return [grid, propertiesView]
    }

    return (grid && propertiesView === 'grid');*/
}

export function showHayaatBanner(city_id, district_id, deal_type, propertyTypes) {

    let types = [];
    if (!isEmpty(propertyTypes) && propertyTypes.length) {
        for (let type of propertyTypes) {
            const propertyType = type.split('.');

            types = [...types, ...propertyType];
        }
    }

    const ignoreCities = [
        259, // تهران
        3165, // پردیس
    ];

    return false;
    /*return (
        !inArray(city_id, ignoreCities) &&
        deal_type === 'sale' &&
        inArray('apartment', array_unique(types))
    );*/
}